import { useState } from 'react'

import { useInterval } from '@chakra-ui/react'

import { getMockAutoplayDelay, isChromakeyModeActive, isMockActive, isMockAutoplayRequested } from 'src/utils/env'

import * as S from './styles'

const MOCK_AUTOPLAY_CHECK_INTERVAL = 1000
const formatAutoplayTimeout = (timeToAutoplay: number) => ` (${Math.round(timeToAutoplay / 1000)}s)`

export const WaitingForTranscriptTemplate = () => {
    const [isMockAutoplayNeeded, setIsMockAutoplayNeeded] = useState(isMockAutoplayRequested() && isMockActive())
    const [timeToAutoplay, setTimeToAutoplay] = useState(getMockAutoplayDelay())

    useInterval(
        () => {
            const nextTimeToAutoplay = Math.max(timeToAutoplay - MOCK_AUTOPLAY_CHECK_INTERVAL, 0)
            if (nextTimeToAutoplay <= 0) {
                document.mocks.getLiveEventPlayer().play()
                setIsMockAutoplayNeeded(false)
            }
            setTimeToAutoplay(nextTimeToAutoplay)
        },
        isMockAutoplayNeeded ? MOCK_AUTOPLAY_CHECK_INTERVAL : null,
    )

    return (
        <S.TemplateContent>
            {!isChromakeyModeActive && <S.StyledTranscriptIcon />}
            <S.TemplateDescription>
                <div>The transcript will be displayed</div>
                <div>
                    here when the session starts
                    {isMockAutoplayNeeded && timeToAutoplay ? formatAutoplayTimeout(timeToAutoplay) : ''}.
                </div>
            </S.TemplateDescription>
        </S.TemplateContent>
    )
}
